import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["limit", "actors"];
import { generateActivityFiltersV3 } from '../utils';
/**
 * This is the query builder for the v3 - myActivity API
 *
 * @param filters
 */
var generateV3MyActivityFilters = function generateV3MyActivityFilters() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var limit = filters.limit,
    actors = filters.actors,
    restFilters = _objectWithoutProperties(filters, _excluded);
  return generateActivityFiltersV3(restFilters);
};
export default generateV3MyActivityFilters;